export default {"src":"https://webcdn.trailways.com/_next/static/media/circle-info.83964fc9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};